import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ScreeningConfigStateService {
  private showMonitoringSubject = new BehaviorSubject<boolean>(false);
  private showBulkSearchSubject = new BehaviorSubject<boolean>(false);
  private monitoringAvailableSubject = new BehaviorSubject<number | null>(null);
  private bulkSearchGuardLoadingSubject = new BehaviorSubject<boolean>(false);
  private externalidEnableSubject = new BehaviorSubject<boolean>(false);

  // Expose as observables
  showMonitoring$: Observable<boolean> =
    this.showMonitoringSubject.asObservable();
  showBulkSearch$: Observable<boolean> =
    this.showBulkSearchSubject.asObservable();
  monitoringAvailable$: Observable<number | null> =
    this.monitoringAvailableSubject.asObservable();
  bulkSearchGuardLoading$: Observable<boolean> =
    this.bulkSearchGuardLoadingSubject.asObservable();
  externalidEnable$: Observable<boolean> =
    this.externalidEnableSubject.asObservable();

  // Getters for current value
  get showMonitoring(): boolean {
    return this.showMonitoringSubject.value;
  }
  get showBulkSearch(): boolean {
    return this.showBulkSearchSubject.value;
  }
  get bulkSearchGuardLoading(): boolean {
    return this.bulkSearchGuardLoadingSubject.value;
  }
  get externalidEnable(): boolean {
    return this.externalidEnableSubject.value;
  }

  // Methods to update flags (should only be called from API logic)
  setConfig(config: {
    monitoringEnable?: boolean;
    batchScreeningEnable?: boolean;
    externalidEnable?: boolean;
  }) {
    this.showMonitoringSubject.next(!!config.monitoringEnable);
    this.showBulkSearchSubject.next(!!config.batchScreeningEnable);
    this.externalidEnableSubject.next(!!config.externalidEnable);
  }

  setMonitoringAvailable(value: number | null) {
    this.monitoringAvailableSubject.next(value);
  }

  setBulkSearchGuardLoading(value: boolean) {
    this.bulkSearchGuardLoadingSubject.next(value);
  }

  get monitoringAvailable(): number | null {
    return this.monitoringAvailableSubject.value;
  }

  reset() {
    this.showMonitoringSubject.next(false);
    this.showBulkSearchSubject.next(false);
    this.monitoringAvailableSubject.next(null);
    this.bulkSearchGuardLoadingSubject.next(false);
    this.externalidEnableSubject.next(false);
  }
}
